import React from 'react';
import PropTypes from 'prop-types';

class PageContent extends React.Component {
  componentWillMount = () => {
    document.title = this.props.pageTitle;
  };

  render() {
    const permSide = this.props.permanentSidePanel ? true : null;
    return (
      <section className="flex-wrapper">
        <input id="slide-menu" type="checkbox" className="slider-checkbox" checked={permSide} readOnly={permSide} />
        {this.props.children}
      </section>
    );
  }
}

PageContent.defaultProps = {
  permanentSidePanel: false,
};

PageContent.propTypes = {
  children: PropTypes.node.isRequired,
  pageTitle: PropTypes.string.isRequired,
  permanentSidePanel: PropTypes.bool,
};

export default PageContent;
